import {
  FETCH_USERSLIST_REQUEST,
  FETCH_USERSLIST_SUCCESS,
  FETCH_USERSLIST_FAILURE,
} from "./usersTypes";

const initialState = {
  loading: false,
  usersList: [],
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USERSLIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_USERSLIST_SUCCESS:
      return {
        loading: false,
        usersList: action.payload,
        error: "",
      };
    case FETCH_USERSLIST_FAILURE:
      return {
        loading: false,
        usersList: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
